import elementResizeDetectorMaker from 'element-resize-detector'

export function sendMsg(msg) {
  window?.parent?.postMessage(JSON.stringify(msg), '*')
}

export function sendThisMsg(msg) {
  window?.postMessage(JSON.stringify(msg), '*')
}

export function watchMsg(fun) {
  window.addEventListener('message', (e) => {
    if (typeof e.data !== 'string') return
    fun(JSON.parse(e.data))
  })
}

export function setHeight(height) {
  return sendMsg({ event: 'setHeight', height })
}

const erd = elementResizeDetectorMaker()

export function listenBodyHeight() {
  erd.listenTo(document.body, (element) => {
    sendMsg({ event: 'setHeight', height: element.offsetHeight })
  })
}

export function unListenBodyHeight() {
  erd.uninstall(document.body)
}

export function showMsg(tipType) {
  sendMsg({ event: 'showMsg', tipType })
}
